import { isNonRunner } from "../isNonRunner";
export const filterOutrightSelections = (selections) => {
    let activeSelection = selections.filter((s) => !s.isDisabled || isNonRunner(s));
    return activeSelection.filter((s) => s.tags && s.tags.indexOf("Place") < 0);
};
//# sourceMappingURL=filterOutrightSelections.js.map